import cn from "classnames"

import { Price, Discount } from "components"
import { Client, Psychologist } from "utils/interfaces"
import { Img, Text } from "ui-kit/components-branded/index"
import { CURRENCY } from "utils/constants"
import { INITIATOR } from "modules/BookingCommon/components/DatePicker/constants"
import { AlterGuaranties } from "modules/Booking/components/AlterGuaranties"
import { getServiceName } from "modules/BookingCommon/common/utils/getServiceName"
import { NextPageButton } from "modules/BookingCommon/components/CardsPage/components/NextPageButton"
import { useOnlyFreeSessions } from "pages/FreePsysPage/useOnlyFreeSessions"
import { ServicesGroup } from "utils/helpers/ServicesGroup"
import { useShowPrice } from "utils/hooks/useShowPrice"

interface Props {
    serviceGroup: ServicesGroup | undefined
    psy: Psychologist
    currency: CURRENCY
    client?: Client
    initiator: INITIATOR

    nextPage: () => void
    onClickNextPage?: () => void
}

export function SessionInfoCard({
    serviceGroup,
    psy,
    currency,
    client,
    initiator,
    nextPage,
    onClickNextPage,
}: Props) {
    const onlyFree = useOnlyFreeSessions()
    const isShowPrice = useShowPrice()
    return (
        <div className="booking-cards__session-info-container">
            <div className="booking-cards__session-info">
                <div>
                    <div className="booking-cards__session-info-headline">
                        Информация о&nbsp;сессии
                    </div>
                    <div className="booking-cards__session-info-description">
                        <div
                            className={cn("booking-cards__session-info-family-or-single-person", {
                                "is-no-first-letter":
                                    initiator === INITIATOR.PSYCHOLOGIST && !serviceGroup?.family,
                            })}
                        >
                            {getServiceName(serviceGroup, initiator)}
                        </div>
                        {client && <Text className="is-block mt-2">Клиент: {client.name}</Text>}
                    </div>
                </div>
                {isShowPrice && (
                    <div className="booking-cards__session-info-price-container">
                        <div className="booking-cards__session-info-price">
                            <Img className="booking__small-emoji" src="credit-card-emoji.png" />
                            {onlyFree ? (
                                "Бесплатно"
                            ) : (
                                <>
                                    Стоимость&nbsp;
                                    <Price
                                        services={serviceGroup?.services}
                                        className="is-lowercase"
                                        psy={psy}
                                        currency={currency}
                                    />
                                </>
                            )}
                        </div>

                        <Discount
                            services={serviceGroup?.services}
                            className="is-lowercase booking-cards__session-info-price-discount"
                            psy={psy}
                        />
                    </div>
                )}
                <NextPageButton
                    regimen="desktop"
                    serviceGroup={serviceGroup}
                    psy={psy}
                    initiator={initiator}
                    nextPage={nextPage}
                    onClickButton={onClickNextPage}
                />
            </div>
            {initiator === INITIATOR.CLIENT && <AlterGuaranties />}
        </div>
    )
}
